import React, { useEffect, useState } from "react";
import styles from "./PreviewV3.module.css";

const PRE_START_SECTIONS = [
  { label: "Pre-Start Details", targetId: "prestart-sec-details" },
  { label: "Checklist Questions", targetId: "prestart-sec-questions" },
  {
    label: "Flagged Non-Conformances & Corrective Actions",
    targetId: "prestart-sec-flagged"
  },
  { label: "Pre-Start Sign Off", targetId: "prestart-sec-signoff" }
];

export default function PreStartPreviewNav({ swmsNumber }) {
  const firstSectionTargetId = PRE_START_SECTIONS[0].targetId;
  const [activeSectionTargetId, setActiveSectionTargetId] = useState(firstSectionTargetId);

  useEffect(() => {
    setActiveSectionTargetId(firstSectionTargetId);
  }, [firstSectionTargetId]);

  return (
    <aside className={styles.PreviewNav}>
      <div className={styles.PreviewNavCard}>
        <div className={styles.PreviewNavHead}><h3>Document Sections</h3></div>
        {swmsNumber ? (
          <div className={styles.PreviewNavDocumentNumber}>{swmsNumber}-PSC</div>
        ) : null}
        <div className={styles.PreviewNavList} id="prestart-prv-nav-list">
          {PRE_START_SECTIONS.map((section, index) => {
            const isActive = activeSectionTargetId === section.targetId;

            const handleClick = (event) => {
              event.preventDefault();
              setActiveSectionTargetId(section.targetId);

              const targetElement = document.getElementById(section.targetId);
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            };

            return (
              <a
                key={section.targetId}
                className={`${styles.PreviewNavItem} ${isActive ? styles.PreviewNavActiveItem : ""}`}
                data-target={section.targetId}
                onClick={handleClick}
              >
                <span className={styles.PreviewNavNum}>{index + 1}</span> {section.label}
              </a>
            );
          })}
        </div>
      </div>
    </aside>
  );
}